
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */

import DocsBeta from 'src/components/docs/DocsBeta/index.tsx';
import Partnership from '../../../../components/docs/plaidoms/Partnership';
export const metadata = {
  toc: true,
  layout: 'guide',
  skipLLM: true,
  maxTocLevel: 4,
  description: 'Report positive-only rent payments to Experian, Equifax, and TransUnion with Esusu and Plaid'
};
export const partnerProps = {
  partner: 'Esusu',
  clientLibrary: 'esusu',
  subtitle: metadata.description,
  registrationUrl: 'https://esusurent.com/rent-reporting-as-a-service',
  apiUrl: 'https://esusurent.com/rent-reporting-as-a-service',
  isPaymentProcessor: false
};

const layoutProps = {
  metadata,
partnerProps
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <Partnership.Header {...partnerProps} />
    <h4 {...{
      "id": "overview"
    }}>{`Overview`}</h4>
    <p>{`Plaid and Esusu have partnered to enable businesses to seamlessly offer positive-only rent reporting for their users through bank integration. Leveraging Esusu's industry-leading rent reporting services, businesses can now report current and historical rent payments to all three major credit bureaus — Equifax, TransUnion, and Experian. This partnership ensures that businesses can rely on Esusu for comprehensive services, including payment labeling, lease management, dispute management, and more, providing a robust solution for enhancing users' credit profiles.`}</p>
    <p>{`With the Plaid + Esusu integration, businesses can use Plaid Link to instantly connect customer bank accounts and detect compliant rent payments with ease. By leveraging the Plaid processor token along with Esusu's proprietary technology, rent payments from accounts linked to your platform can be accurately identified and reported. End-users only need to link their bank account once, enabling you to offer rent reporting as a streamlined and convenient service that enhances the overall user experience.`}</p>
    <h4 {...{
      "id": "getting-started"
    }}>{`Getting Started`}</h4>
    <Partnership.GettingStarted {...partnerProps} />
    <h4 {...{
      "id": "instructions"
    }}>{`Instructions`}</h4>
    <Partnership.TransactionsInstructions {...partnerProps} />
    <Partnership.TransactionsServer {...partnerProps} />
    <h4 {...{
      "id": "launching-to-production"
    }}>{`Launching to Production`}</h4>
    <Partnership.TransactionsConclusion {...partnerProps} />
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;

            export const tableOfContents = [
      {
        id: "overview",
        level: 4,
        title: "Overview",
      },
{
        id: "getting-started",
        level: 4,
        title: "Getting Started",
      },
{
        id: "instructions",
        level: 4,
        title: "Instructions",
      },
{
        id: "launching-to-production",
        level: 4,
        title: "Launching to Production",
      }
];
          
layoutProps.tableOfContents = tableOfContents;
MDXContent.layoutProps = layoutProps;

MDXContent.layout = function (props) { return <DocsBeta {...props} /> };
